const API_URL = 'https://producthired.com';
const subUrl = 'api/api';

export { API_URL, subUrl };
